import React, {useRef, useLayoutEffect, useState, useEffect} from "react";
// import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import Link from "./Link";
import {useMenuItems} from "/src/_hooks/useMenuItems";
import styled from "styled-components";
import gsap from "gsap";
import {useACFOptions} from "../../_hooks/useACFOptions";
import SocialLink from "./SocialLink";

const ToggleBtn = styled.button`
  background: var(--header-items-bg, var(--bs-primary));
  color: var(--header-items-color, var(--bs-linen));
  transform-origin: 100% 0%;
  width: 40px;
  height: 40px;
  padding: 0;
  @media (min-width: 640px) {
    width: 50px;
    height: 50px;
  }
  &:hover{
    color: var(--header-items-hover-color, var(--bs-primary));
    background: var(--header-items-hover-bg, var(--bs-lime-green));
  }
`
const NavShade = styled.div`
  width: 40px;
  height: 40px;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  pointer-events: none;
  transform-origin: 95% 2%;
  @media (min-width: 640px) {
    transform-origin: 85% 4%;
    width: 50px;
    height: 50px;
  }
`
const Nav = styled.nav`
  width: 100%;
  height: var(--app-height, 100vh);
  position: fixed;
  right: 0;
  top: 0;
  //transform-origin: 92% 4%;
  opacity: 0;
  visibility: hidden;

  .navbar-nav{
    --bs-nav-link-font-size:38px;
    --bs-nav-link-font-weight:400;
    --bs-nav-link-hover-color: var(--bs-forest-green);
    --bs-nav-link-color: var(--bs-white);
    --bs-navbar-active-color: var(--bs-forest-green);
    counter-reset: nav-item-index;
    gap: 10px;
    @media (min-width: 640px) {
      --bs-nav-link-font-size:44px;
    }
    @media (min-width: 640px) and (orientation: landscape) and (max-width: 991px) {
      --bs-nav-link-font-size:32px;
      display: block !important;
      column-count: 2;
      column-gap: 8px !important;
      margin-bottom: 10px;
      & > li{
        break-inside: avoid;
        padding: 8px 0;
        a{
          display: block;
          width: fit-content;
        }
      }
    }

    @media (min-width: 992px) {
      --bs-nav-link-font-size:60px;
    }
    @media (min-width: 1440px) and (min-height: 650px) {
      --bs-nav-link-font-size:60px;
    }
    @media (min-width: 1440px) and (min-height: 920px) {
      --bs-nav-link-font-size:84px;
    }

  }
  .nav-link{
    line-height: 1;
    position:relative;
    @media (min-width: 640px) {
      line-height: 1;
      letter-spacing: -0.01em;
      &:before{
        font-size: 24px;
        margin-right: 12px;
        margin-bottom: 0;
        letter-spacing: normal;
      }
    }
    &.active {
      &:after {
        content: '';
        position: absolute;
        top: -7px;
        left: -8px;
        right: -8px;
        bottom: -7px;
        background-color: var(--bs-lime-green);
        z-index: -1;
        @media (min-width: 992px) {
          top: 0;
          bottom: 0;
        }
      }
    }
  }
`

const Menu = ({location}) => {
  const {footer} = useACFOptions();
  const menuItems = useMenuItems(location);
  const navRef = useRef(null);
  const navList = useRef(null);
  const openBtn = useRef(null);
  const closeBtn = useRef(null);
  const shadeBtn = useRef(null);
  const shareRef = useRef(null);
  const linesRef = useRef(null);

  const tl = useRef();

  const [reversed, setReversed] = useState(true);

  const navToggle = () => {
    // document.body.classList.toggle('overflow-hidden');
    !tl.current.isActive() && setReversed(!reversed);
  };
  const scrollLockToggle = (value) => {

    if (document.body.offsetWidth >= 640) return;
    document.body.style.overflow = value ? null : "hidden";

    // value ? enableBodyScroll(document.documentElement) : disableBodyScroll(document.documentElement)
  };


  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      let mm = gsap.matchMedia();

      tl.current = gsap.timeline({})
        .to(shadeBtn.current, {
          opacity: 1,
          duration:0.1
        })
        .set(openBtn.current, {autoAlpha: 0})

      tl.current.to(shadeBtn.current, {
        duration: 0.4,
        // borderRadius: '40px',
        // width: () => navRef.current.offsetWidth,
        // height: () => navRef.current.offsetHeight,
        scaleX: navRef?.current ? (navRef.current.offsetWidth / shadeBtn.current.offsetWidth) + 0.5 : 1,
        scaleY: navRef?.current ? (navRef.current.offsetHeight / shadeBtn.current.offsetHeight) + 0.5 : 1,
        ease: 'power3.in',
      })

      mm.add("(max-width: 639px)", () => {
        // tl.current.to(shadeBtn.current, {
        //   duration: 0.4,
        //   scale: 25,
        //   ease: "power3.in",
        //   // transformOrigin: "70% 20%",
        // })
      });
      mm.add("(min-width: 640px)", () => {

      });

      tl.current
        .set(navRef.current, {
          autoAlpha: 1
        })
        // .to(openBtn.current, {
        //   scale: 0,
        //   duration: 0.4,
        //   // ease: 'back.out(1.2)',
        // }, '<')
        .from(navList.current?.children || [], {y:20, opacity:0, duration:0.2, stagger:0.05}, '+=0.05')
        .from(closeBtn.current, {scale:0, ease: 'back.out(1.1)', duration:0.3}, '<')
        .from(shareRef.current, {y:20, opacity:0, duration:0.2}, '<0.2')
        .from(linesRef.current, {opacity:0, duration:0.2}, '<')
        .reverse()

    });


    return () => {
      ctx.revert();
      // clearAllBodyScrollLocks()
    }
  }, []);

  useEffect(() => {
    scrollLockToggle(reversed);
    reversed ? tl.current.reverse() : tl.current.play();
  }, [reversed]);

  return menuItems?.length > 0 ? (
      <div className="pe-auto position-relative">
        <ToggleBtn ref={openBtn} onClick={navToggle} className="position-relative z-1 d-flex justify-content-center align-items-center border-0 p-0" type="button" aria-label="Menu">
          <svg width="28" height="14" viewBox="0 0 30 15" fill="none" className={`flex-shrink-0`}>
            <path d="M1 3.50912C3.87179 1.29032 9.25641 0.778951 13.9231 2.70271C20.6494 5.47551 25.7692 3.22993 29 1.29032" stroke="currentColor" strokeWidth="3"/>
            <path d="M1 12.2188C3.87179 10 9.25641 9.48863 13.9231 11.4124C20.6494 14.1852 25.7692 11.9396 29 10" stroke="currentColor" strokeWidth="3"/>
          </svg>
        </ToggleBtn>
        <NavShade ref={shadeBtn} className="z-2 bg-primary"></NavShade>
        <Nav ref={navRef} className="z-3 bg-primary overflow-hidden">
          <svg ref={linesRef} className="pe-none position-absolute d-none d-lg-block bottom-0 end-0 w-auto h-auto z-0" width="1440" height="920" viewBox="0 0 1440 920" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M-320.2 903.14c1858.49 506.5 1189-899.46 1892.99-606.97" stroke="#0F624A" strokeWidth="18"/>
            <path d="M985.79 1264.67c-50.5-442-170.94-628.35 222-697 363.5-63.5 291.85-405.88 313.5-608" stroke="#C0EF92" strokeWidth="18"/>
          </svg>
          <div className="container h-100 position-relative pt-60 pb-80 py-md-50 py-xl-60">
            <button ref={closeBtn} onClick={navToggle} type="button"
                    className="btn-close position-absolute top-0 end-0 mt-20 mt-md-30 me-20 me-md-24 me-xl-32 z-1">
              <svg width="24" height="24">
                <use xlinkHref="#icon-close"/>
              </svg>
            </button>
            <div
              className="position-relative h-100 d-flex gap-48 gap-xl-0 flex-column justify-content-center">
              <ul ref={navList}
                  className="navbar-nav d-flex flex-column align-items-center align-items-md-start gap-10 gap-md-16 gap-lg-8 text-center">
                {menuItems.map((menuItem, index) => (
                    <li className={`nav-item ${menuItem.cssClasses.join(' ')}`} key={menuItem.id + index}>
                      <Link onClick={navToggle}
                            className="nav-link font-family-heading text-uppercase d-flex flex-column flex-md-row justify-content-center justify-content-md-start text-center text-md-start"
                            to={menuItem.path} target={menuItem.target}>{menuItem.label}</Link>
                    </li>
                  )
                )}
              </ul>
              <div
                ref={shareRef}
                className="position-xl-absolute end-0 bottom-0 d-flex align-items-center justify-content-between justify-content-md-end gap-16 gap-md-32">
                {footer?.socials?.linkedin && (
                  <SocialLink url={footer.socials.linkedin} name="LinkedIn">
                    <svg width="20" height="18">
                      <use xlinkHref="#icon-social-network-linkedin"></use>
                    </svg>
                  </SocialLink>
                )}
                {footer?.socials?.facebook && (
                  <SocialLink url={footer.socials.facebook} name="Facebook">
                    <svg width="11" height="18">
                      <use xlinkHref="#icon-social-network-facebook"></use>
                    </svg>
                  </SocialLink>
                )}
                {footer?.socials?.instagram && (
                  <SocialLink url={footer.socials.instagram} name="Instagram">
                    <svg width="21" height="20">
                      <use xlinkHref="#icon-social-network-instagram"></use>
                    </svg>
                  </SocialLink>
                )}
                {footer?.socials?.youtube && (
                  <SocialLink url={footer.socials.youtube} name="YouTube">
                    <svg width="22" height="16">
                      <use xlinkHref="#icon-social-network-youtube"></use>
                    </svg>
                  </SocialLink>
                )}
              </div>
            </div>
          </div>
        </Nav>
      </div>
  ) : null;
}

export default Menu
